import {
  DELETE_MEDIA_BUYER_BUDGET,
  GET_MEDIA_BUYER_BUDGETS,
  GET_MEDIA_BUYER_DATA_FOR_ADD,
  HIDE_MEDIA_BUYER_BUDGETS_LOADER,
  ADD_MEDIA_BUYER_BUDGET,
  SET_MEDIA_BUYER_BUDGETS,
  SET_MEDIA_BUYER_DATA_FOR_ADD,
  SHOW_MEDIA_BUYER_BUDGETS_LOADER,
  GET_MEDIA_BUYER_BUDGET_FOR_ID,
  SET_MEDIA_BUYER_BUDGET_FOR_ID,
  PATCH_MEDIA_BUYER_BUDGET,
  GET_FILTERED_MEDIA_BUYER_BUDGET,
  ADD_MEDIA_BUYER_BUDGET_BY_OFFER, DELETE_MEDIA_BUYER_BUDGET_BY_OFFER, SET_ERROR_MEDIA_BUYER_BUDGETS
} from "./actionType"

export const getFilteredBudgets = (filter, data) => ({
  type: GET_FILTERED_MEDIA_BUYER_BUDGET,
  payload: { filter, data }
});

export const addMediaBuyerBudgetsByOffer = (budget) => ({
  type: ADD_MEDIA_BUYER_BUDGET_BY_OFFER,
  payload: { budget }
})

export const getMediaBuyerBudgets = data => ({
  type: GET_MEDIA_BUYER_BUDGETS,
  payload: data
});

export const getMediaBuyerBudgetsById = id => ({
  type: GET_MEDIA_BUYER_BUDGET_FOR_ID,
  payload: { id }
});

export const setMediaBuyerBudgetsForId = payload => ({
  type: SET_MEDIA_BUYER_BUDGET_FOR_ID,
  payload
});

export const setMediaBuyerBudgets = payload => ({
  type: SET_MEDIA_BUYER_BUDGETS,
  payload
});

export const showMediaBuyerBudgetLoader = () => ({
  type: SHOW_MEDIA_BUYER_BUDGETS_LOADER
});

export const hideMediaBuyerBudgetLoader = () => ({
  type: HIDE_MEDIA_BUYER_BUDGETS_LOADER
});

export const getMediaBuyerDataForAdd = () => ({
  type: GET_MEDIA_BUYER_DATA_FOR_ADD
});

export const setMediaBuyerDataForAdd = payload => ({
  type: SET_MEDIA_BUYER_DATA_FOR_ADD,
  payload
});

export const addMediaBuyerBudget = (budget = {}, data = {}) => ({
  type: ADD_MEDIA_BUYER_BUDGET,
  payload: { budget, data }
});

export const deleteMediaBuyerBudget = (id, data = {}) => ({
  type: DELETE_MEDIA_BUYER_BUDGET,
  payload: { id, data }
});

export const deleteMediaBuyerBudgetByOffer = (id, offerId) => ({
  type: DELETE_MEDIA_BUYER_BUDGET_BY_OFFER,
  payload: { id, offerId }
});

export const patchMediaBuyerBudget = (id, data = {}) => ({
  type: PATCH_MEDIA_BUYER_BUDGET,
  payload: { id, data }
});

export const setErrorMediaBuyerBudget = status => ({
  type: SET_ERROR_MEDIA_BUYER_BUDGETS,
  payload: status
});
